import { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { Eye, EyeOff, Key, CheckCircle, Loader } from 'lucide-react';
import toast from 'react-hot-toast';

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error('Password must be at least 8 characters');
    if (password !== confirmPassword) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      await authAPI.resetPassword(token, { password });
      setDone(true);
    } catch (_) {}
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/logo.png" alt="AINA" style={{ width: 56, height: 56, borderRadius: 14, objectFit: 'contain' }} />
        </div>

        <div className="card" style={{ padding: 32 }}>
          {done ? (
            <div style={{ textAlign: 'center' }}>
              <CheckCircle size={48} style={{ color: 'var(--green)', marginBottom: 16 }} />
              <h2 style={{ fontSize: '1.2rem', fontWeight: 700, marginBottom: 8 }}>Password Reset</h2>
              <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: 20 }}>
                Your password has been changed. You can now login with your new password.
              </p>
              <Link to="/login" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
                Go to Login
              </Link>
            </div>
          ) : (
            <>
              <h2 style={{ fontSize: '1.2rem', fontWeight: 700, marginBottom: 4 }}>Set new password</h2>
              <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: 20 }}>
                Enter your new password below.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">New Password</label>
                  <div style={{ position: 'relative' }}>
                    <input className="form-input" type={showPass ? 'text' : 'password'}
                      placeholder="Minimum 8 characters" value={password}
                      onChange={e => setPassword(e.target.value)} required
                      style={{ paddingRight: 40 }} />
                    <button type="button" onClick={() => setShowPass(p => !p)}
                      style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer' }}>
                      {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
                    </button>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Confirm Password</label>
                  <input className="form-input" type={showPass ? 'text' : 'password'}
                    placeholder="Repeat password" value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)} required />
                </div>
                <button className="btn btn-primary" type="submit" disabled={loading}
                  style={{ width: '100%', justifyContent: 'center', padding: '11px' }}>
                  {loading ? <Loader size={16} style={{ animation: 'spin 0.7s linear infinite' }} /> : <Key size={15} />}
                  {loading ? 'Resetting...' : 'Reset Password'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
